<template>
    
    
    <div class="column is-half-mobile is-one-fifth-tablet is-one-quarter-desktop">
        
        
        <div class="card">
            <a :href="product.getDetailUrl">
            <div class="card-image has-text-centered">
                <div class="img-overlay">
                    <div class="img-overlay-btn">
                        <b-button
                        class="is-custom"
                        rounded>
                        <b-icon icon="eye" size="is-small"></b-icon>
                        Ver producto                            
                        </b-button>
                    </div>
                </div>
                <div v-if="product.status == 'O'" class="tag is-danger is-rounded sale-tag">
                    Oferta
                </div>
                <img :src="product.getImage" alt="imagen-producto">
            </div>
            </a>
            <div class="card-content">
                <div class="content product-content">
                    <a  :href="product.getDetailUrl">
                    <p class="has-text-weight-semibold has-text-dark">{{product.title}}</p>
                    <div class="price has-text-centered">
                        <p  style=" text-decoration: line-through; color:#333;" v-if="product.status=='O'">
                            {{product.currencySymbol}} {{product.compareAt}}
                        </p>
                        <p class="has-text-custom">{{product.currencySymbol}} {{product.price}}</p>
                    </div>
                    </a>
                    <div v-if="addFromCatalog == 'True'" class="m-t-10 has-text-left">
                        <b-field  label="Cantidad" label-position="on-border">
                            <b-numberinput
                            size="is-small"
                            rounded
                            controls-alignment="left" 
                            controls-position="compact"
                            v-model="prodQ"
                            min="1"
                            type="is-light"
                            class="has-text-left">
                            </b-numberinput>

                            <p class="control">
                                <b-button rounded size="is-small" @click="sendCartItem" :loading="loadAddToCart" type="is-custom">
                                    <b-icon icon="cart-plus" size="is-small" ></b-icon>
                                </b-button>
                            </p>
                        </b-field>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
   
</template>

<script>
import { postHandler } from '../../../../services/http'
export default {
    props:{
        product:{
            type: Object,
            default: new Object({})
        },
        primaryColor:{
            type:String,
            default:""
        },
        blackText:{
            type:String,
            default:""
        },
        cartItemUrl:{
            type:String,
            default:""
        },
        addFromCatalog:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            isStyle:"style",
            prodQ:1,
            loadAddToCart:false
        }
    },
    computed:{
        textColor(){
            if(this.blackText=="True"){
                return 'black'
            } return 'white'
        },
    },
    methods:{
        async sendCartItem(){
            this.loadAddToCart = true
            var cartItem = {
                product:this.product.id,
                values:[],
                variant:"",
                quantity:this.prodQ,
                unitPrice:this.product.price
            }
            var success={
                resource:'notify',
                text:'Producto agregado al carrito con exito'
            }
            var error={
                resource:'notify',
                text:"Parece que ya tienes este producto en el carrito! ve al carro y editalo."
            }
            var resp = await postHandler(this.cartItemUrl, cartItem, {error, success})
            this.loadAddToCart = false
            localStorage.setItem("cartCount", resp.data.cartCount)
            var event = document.createEvent("Event");
            event.initEvent("storage", true, true);
            window.dispatchEvent(event);
        }
    }
}
</script>

<style lang="scss" scoped>

.card{
    height:100%;
    border:0px #fff solid !important;
    box-shadow: 0px 0px 0px 0px #b8b8b8;
    transition: all 1s;
}
.card:hover {
    
    box-shadow: 1px 10px 10px #b8b8b8;
    .card-image{
        img{
            transform: scale(1.1);
        }
        .img-overlay{
            opacity: 1;
        }
    }
    
}
.card-image{
    overflow: hidden;
    img{
        max-height: 200px;
        transition: all 3s;
    }
}
.card-content{
    padding:5px;
}
.product-content{
    margin: 0px;
     p{
        margin:0px;
        padding:0px;
    }
}


.img-overlay{
    position:absolute;
    opacity:0;
    z-index:9;
    width:100%;
    height:100%;
    background: rgba(0, 0, 0, 0.2);
    transition: opacity 0.5s ease-in;
}

.img-overlay-btn{
    position: absolute;
    bottom: 20px;;
    left: 0;
    width: 100%;
}

.is-custom{
    background-color: var(--primary);
    color: var(--text-color);
}

.has-text-custom{
    color: var(--primary)
}

.sale-tag{
    position:absolute;
    left:5px;
    top:5px;
    z-index:10;
}

</style>

